/* unplugin-vue-components disabled */import { render } from "./MPIcon.vue?vue&type=template&id=3abb2b99&scoped=true&ts=true"
import script from "./MPIcon.vue?vue&type=script&lang=ts"
export * from "./MPIcon.vue?vue&type=script&lang=ts"

import "./MPIcon.vue?vue&type=style&index=0&id=3abb2b99&lang=scss&scoped=true"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3abb2b99"],['__file',"src/baseui/player/MPIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3abb2b99"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3abb2b99', __exports__)) {
    console.log('reload')
    api.reload('3abb2b99', __exports__)
  }
  
  module.hot.accept("./MPIcon.vue?vue&type=template&id=3abb2b99&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('3abb2b99', render)
  })

}


export default __exports__